module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-roots"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "title",
    class: {
      hide: !_vm.isShowTitle
    }
  }, [_c('span', [_vm._v("RESUME")])]), _vm._v(" "), (_vm.isShowBook) ? _c('book', {
    attrs: {
      "defaultPageNumber": 3
    }
  }, [_c('page1', {
    slot: "page1"
  }), _vm._v(" "), _c('page2', {
    slot: "page2"
  }), _vm._v(" "), _c('page3', {
    slot: "page3"
  }), _vm._v(" "), _c('page4', {
    slot: "page4"
  }), _vm._v(" "), _c('div', {
    staticClass: "first",
    slot: "page5"
  }, [_vm._v("555")]), _vm._v(" "), _c('div', {
    staticClass: "first",
    slot: "page6"
  }, [_vm._v("666")]), _vm._v(" "), _c('div', {
    staticClass: "first",
    slot: "page7"
  }, [_vm._v("777")]), _vm._v(" "), _c('div', {
    staticClass: "first",
    slot: "page8"
  }, [_vm._v("...")]), _vm._v(" "), _c('div', {
    slot: "page9"
  }), _vm._v(" "), _c('div', {
    slot: "page10"
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b9fb01f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/resume/index.vue
// module id = 184
// module chunks = 0